import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'baseui/snackbar'
import { fidelityMaximizerModuleActions } from './FidelityMaximizerSagas'
import {
  selectConfig,
  selectContactConfig,
  selectFidelityMaximizerState,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import useFidelityMaximizerEligibility from './useFidelityMaximizerEligibility'

const useFidelityMaximizer = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()
  const { contactId } = useSelector(selectConfig)
  const { contractLoaded } = useSelector(selectContactConfig)
  const fidelityMaximizer = useSelector(selectFidelityMaximizerState)
  const { loading, loaded, enabled, checklist, isPdlEligible, scenarioKey, actionKey, actionAvailable, actionLoading } =
    fidelityMaximizer

  const isEligibleAgent = useFidelityMaximizerEligibility()

  useEffect(() => {
    if (!contractLoaded || !contactId || !isEligibleAgent || loaded || loading) {
      return
    }

    dispatch({ type: fidelityMaximizerModuleActions.FIDELITY_MAXIMIZER_LOAD_STATUS, contactId })
  }, [contractLoaded, contactId, isEligibleAgent, loaded, loading])

  const triggerAction = () => {
    if (!actionKey || !actionAvailable || actionLoading) {
      return
    }

    dispatch({
      type: fidelityMaximizerModuleActions.FIDELITY_MAXIMIZER_TRIGGER_ACTION,
      contactId,
      action: actionKey,
      enqueue,
    })
  }

  return {
    t,
    hidden: !isEligibleAgent || !loaded || !enabled,
    loading,
    checklist,
    isPdlEligible,
    scenarioKey,
    actionAvailable,
    actionLoading,
    triggerAction,
  }
}

export default useFidelityMaximizer
